import { Link } from "react-router-dom";
import { availableCash, parseCashPosition } from "../../services/cashPosition";
import { formatCurrency } from "../../utils/pricing";

export function CashPositionCard({
  description,
}: {
  description?: string | null;
}) {
  const cash = parseCashPosition(description);
  if (!cash) return null;
  return (
    <section
      className="rounded-lg border border-blue-200 bg-blue-50 p-5 space-y-3"
      aria-label="Cassa attuale dichiarata"
    >
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h3 className="font-semibold text-lg">
          Cassa dichiarata al {cash.date.split("-").reverse().join("/")}
        </h3>
        <span className="text-2xl font-bold">
          {formatCurrency(cash.balance)}
        </span>
      </div>
      <p className="text-sm">
        Saldo già netto delle spese pagate. È una fotografia comunicata, non un
        saldo bancario aggiornato automaticamente.
      </p>
      <dl className="grid gap-3 sm:grid-cols-3 text-sm">
        <div>
          <dt>Impegni noti da saldare</dt>
          <dd className="font-semibold">{formatCurrency(cash.unpaidKnown)}</dd>
        </div>
        <div>
          <dt>Accantonamento proposto recinto</dt>
          <dd className="font-semibold">
            {formatCurrency(cash.fenceAllocation)}
          </dd>
        </div>
        <div>
          <dt>
            {cash.reserve === null
              ? "Residuo prima della riserva familiare"
              : "Residuo dopo riserva familiare"}
          </dt>
          <dd className="font-semibold">
            {formatCurrency(availableCash(cash))}
          </dd>
        </div>
      </dl>
      <p className="text-sm">
        Versamento dichiarato: almeno {formatCurrency(cash.monthlyConfirmed)}
        /mese; altri {formatCurrency(cash.monthlyPossible)}/mese da confermare.
        {!cash.monthlyStart && " Inizio dei versamenti ancora da definire."}
        {cash.reserve === null && " Riserva familiare ancora da definire."}
      </p>
      <p className="text-sm">
        Vendita appartamento possibile: {formatCurrency(cash.potentialSale)},
        esclusa dal saldo. Trabattello opzionale:{" "}
        {formatCurrency(cash.optionalScaffold)}, non ancora sottratto.
      </p>
      <Link to="/task" className="text-sm font-medium underline">
        Vedi registro cassa e impegni nelle attività
      </Link>
    </section>
  );
}
